import { jwtDecode } from 'jwt-decode';
import cookie from '@/presentation/libs/cookie.lib';
import { normalizeBusinessInfo } from '@/presentation/modules/business/utils/workHours.mapper';
import { getClaimsFromAccessToken } from '@/presentation/router/defaultRoute.router';

const actions = {
	setUserInformationOfToken(token: string) {
		const claims = getClaimsFromAccessToken(token);
		this.userInformation.name = claims.name ?? '';
		this.userInformation.phoneNumber = claims.phoneNumber ?? '';
		this.userInformation.userId = claims.userId ?? '';
		this.userInformation.role = claims.role ?? 'AllUser';
		this.userInformation.roles = claims.roles.length > 0 ? claims.roles : (claims.role ? [claims.role] : []);
		this.userInformation.activeContext = claims.activeContext ?? claims.role ?? '';
		this.userInformation.professionalId = claims.professionalId ?? null;
		this.userInformation.businessId = claims.businessId ?? null;
		this.userInformation.loggedIn = true;
	},
	setUserInformation(userInformation: any) {
		if (!userInformation) return;
		this.userInformation.name = userInformation.fullName ?? this.userInformation.name;
		this.userInformation.phoneNumber = userInformation.phoneNumber ?? this.userInformation.phoneNumber;
		this.userInformation.userId = userInformation.id ?? this.userInformation.userId;
		this.userInformation.city = userInformation.city ?? this.userInformation.city;
		this.userInformation.profileImagePath = userInformation.profileImagePath ?? '';
		this.userInformation.loggedIn = true;
	},
	logout() {
		cookie.remove('temp-token');
		cookie.remove('access-token');
		cookie.remove('refresh-token');
		this.resetStore();
	},
	setBusinessInfo(businessInfo: object) {
		this.businessInfo = normalizeBusinessInfo(businessInfo);
	},
	setBusinessInfoSelected(info) {
		this.businessSelected = normalizeBusinessInfo(info);
	},
	setArtistInfo(artistInfo: object) {
		this.artistInfo = { ...artistInfo };
	},
	setSelectedArtists(artists: any[]) {
		this.selectedArtists = [...artists];
		this.artistInfo = artists.length === 1 ? { ...artists[0] } : {};
	},
	setSelectedArtistPreferences(preferences: any[]) {
		this.selectedArtistPreferences = [...preferences];
	},
	setArtistSelectionSkipped(isSkipped: boolean) {
		this.artistSelectionSkipped = isSkipped;
	},
	setServiceInfo(serviceInfo: any[]) {
		this.serviceInfo = [...serviceInfo];
	},
	setTimeInfo(timeInfo: object) {
		this.timeInfo = { ...timeInfo };
	},
	setBookingSuggestion(suggestion: object | null, mode = 'Together') {
		this.bookingSuggestion = suggestion ? { ...suggestion } : null;
		this.bookingSuggestionExpiresAt = suggestion ? Date.now() + 10 * 60 * 1000 : null;
		this.bookingMode = mode;
		this.splitBookingConfirmed = false;
	},
	confirmSplitBooking() {
		this.bookingMode = 'Split';
		this.splitBookingConfirmed = true;
	},
	clearBookingSuggestion() {
		this.bookingMode = 'Together';
		this.bookingSuggestion = null;
		this.bookingSuggestionExpiresAt = null;
		this.splitBookingConfirmed = false;
	},

	resetStore() {
		this.userInformation = {
			name: '',
			phoneNumber: '',
			userId: '',
			role: 'AllUser',
			roles: [],
			activeContext: '',
			professionalId: null,
			businessId: null,
			loggedIn: false,
			city: {},
			profileImagePath: '',
		};
		this.businessInfo = {};
		this.artistInfo = {};
		this.selectedArtists = [];
		this.selectedArtistPreferences = [];
		this.artistSelectionSkipped = false;
		this.serviceInfo = [];
		this.timeInfo = {};
		this.bookingMode = 'Together';
		this.bookingSuggestion = null;
		this.bookingSuggestionExpiresAt = null;
		this.splitBookingConfirmed = false;
	},
};

export default actions;
